<a [hidden]="!showHelpCenterIcon" class="helpFont pl-1 text-decoration-none" target="_blank" [href]="pageUrl"><i class="far fa-question-circle helpIcon"></i><span class="text-decoration-undeline pl-1">{{ displayText == '' ? '' : 'admin.store.help.helpText' | translate}} {{ displayText | translate}}</span>
</a>
